import { render, staticRenderFns } from "./SendByWhatsApp.vue?vue&type=template&id=5cadbf72&"
import script from "./SendByWhatsApp.vue?vue&type=script&lang=js&"
export * from "./SendByWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports